const historyOptionCases = {
  DOCUMENT: 'DOCUMENT',
  RESULTS_VIEWER: 'RESULTS_VIEWER',
  RESULTS_VIEWER_URL: 'RESULTS_VIEWER_URL',
  IMAGE: 'IMAGE'
};

const historyOptionsActions = {
  DOCUMENT: 'HAS_RESULTS',
  RESULTS_VIEWER: 'HAS_RESULTS_VIEWER',
  RESULTS_VIEWER_URL: 'HAS_RESULTS_VIEWER_URL',
  IMAGE: 'HAS_IMAGES_VIEWER'
};

const historyOptionPermission = {
  DOCUMENT: 'clinical_history:download_results',
  RESULTS_VIEWER: 'clinical_history:download_viewer_results',
  RESULTS_VIEWER_URL: 'clinical_history:download_viewer_results',
  IMAGE: 'clinical_history:download_viewer_images'
};

const historyOptionValues = {
  DOCUMENT: {
    id: -1,
    name: 'SI_DOCUMENT',
    type: historyOptionCases.DOCUMENT
  },
  RESULTS_VIEWER: {
    id: -2,
    name: 'SI_RESULTS',
    type: historyOptionCases.RESULTS_VIEWER
  },
  RESULTS_VIEWER_URL: {
    id: -3,
    name: 'SI_RESULTS',
    type: historyOptionCases.RESULTS_VIEWER_URL
  },
  IMAGE: {
    id: -4,
    name: 'SI_MEDICAL_IMAGES',
    type: historyOptionCases.IMAGE
  }
};

export {
  historyOptionValues,
  historyOptionCases,
  historyOptionsActions,
  historyOptionPermission
};
